export default "__VITE_ASSET__DtuU4kSJ__"